"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("react");
const react_dom_1 = tslib_1.__importDefault(require("react-dom"));
const PORTAL_ROOT_ID = "video-portal-root";
function Portal({ children }) {
    const [portalRoot, setPortalRoot] = (0, react_1.useState)(null);
    (0, react_1.useLayoutEffect)(() => {
        var _a;
        const topMostWindow = window.top;
        const existingRoot = topMostWindow === null || topMostWindow === void 0 ? void 0 : topMostWindow.document.querySelector(`#${PORTAL_ROOT_ID}`);
        const root = (_a = existingRoot !== null && existingRoot !== void 0 ? existingRoot : topMostWindow === null || topMostWindow === void 0 ? void 0 : topMostWindow.document.createElement("div")) !== null && _a !== void 0 ? _a : null;
        setPortalRoot(root);
        if (!root || existingRoot) {
            if (!root) {
                console.error("Failed to create portal root");
            }
            return;
        }
        root.setAttribute("id", PORTAL_ROOT_ID);
        topMostWindow === null || topMostWindow === void 0 ? void 0 : topMostWindow.document.body.appendChild(root);
    }, []);
    return react_dom_1.default.createPortal(children, portalRoot !== null && portalRoot !== void 0 ? portalRoot : document.body);
}
exports.default = Portal;
//# sourceMappingURL=index.js.map